export const selectInputClassNames = [
    '@flex',
    '@justify-between',
    '@items-center',
    '@p-2',
    '@text-grey-6',
    '@text-b2',
    '@font-medium',
    '@border',
    '@border-grey-2_5',
    '@bg-grey-2-a',
    'focus:@outline-none',
    'disabled:@cursor-not-allowed',
    'disabled:@bg-grey-2',
    'disabled:@text-grey-4',
    '[&>span]:@line-clamp-1',
    '@rounded',
];
export const selectIconClassNames = [
    '@h-4',
    '@w-4',
    '[[data-state="open"]_&]:@rotate-180',
];
export const selectContentClassNames = [
    '@relative',
    '@z-50',
    // '@max-h-96',
    // '@min-w-40',
    '@overflow-hidden',
    '@rounded-lg',
    '@border',
    '@border-grey-2_3',
    '@bg-grey-1',
    '@text-grey-6',
    '@shadow-down6',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0',
    'data-[state=closed]:@zoom-out-95',
    'data-[state=open]:@zoom-in-95',
    'data-[side=bottom]:@slide-in-from-top-2',
    'data-[side=left]:@slide-in-from-right-2',
    'data-[side=right]:@slide-in-from-left-2',
    'data-[side=top]:@slide-in-from-bottom-2'
];
export const selectViewportPopperClassNames = [
    '@max-h-[calc(var(--radix-select-content-available-height)_-_var(--radix-select-trigger-height))]',
    '!@flex-none',
    '@w-full',
    '@min-w-[var(--radix-select-trigger-width)]',
];
export const selectItemClassNames = [
    '@relative',
    '@flex',
    '@w-full',
    '@cursor-default',
    '@select-none',
    '@items-center',
    '@justify-between',
    '@rounded-sm',
    '@p-2',
    '@text-b2',
    '@outline-none',
    'data-[state="checked"]:@text-brand1-1',
    'focus:@bg-accent',
    'focus:@text-accent-foreground',
    'data-[disabled]:@pointer-events-none',
    'data-[disabled]:@opacity-50'
];
export const selectItemIconClassNames = [
    '@w-4',
    '@h-4',
];
